<template>
  <div v-if="this.$store.state.server">
    <p class="error">{{ error }}</p>
    <div>
      <b-form-checkbox
        id="checkbox-1"
        v-model="status"
        name="checkbox-1"
        value="Back"
        unchecked-value="No back"
      >Back</b-form-checkbox>
    </div>
    <b-row>
      <b-col>QR :</b-col>
      <b-col>
        <b>{{ result }}</b>
      </b-col>
    </b-row>
    <!-- {{test}} -->
    <b-row>
      <b-col>
        <b-form-input id="name-input" v-model="test" class="text-left"></b-form-input>
      </b-col>
      <b-col>
        <b-button variant="outline-primary" @click="postlogin2()">test</b-button>
      </b-col>
    </b-row>
    <b-modal ref="modal" title="ชำระเงิน" @shown="showmodal" @hidden="hiddenmodal">
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label-cols="4"
          label-cols-lg="2"
          label-size="sm" 
          label="มากกว่าสามชั่วโมง"
          label-for="input-sm"
        >
          <b-form-input id="name-input" v-model="time3hr" disabled class="text-right"></b-form-input>
        </b-form-group>
        <b-form-group
          label-cols="4"
          label-cols-lg="2"
          label-size="sm"
          label="QR"
          label-for="input-sm"
        >
          <b-form-input id="name-input" v-model="item.qr" disabled class="text-right"></b-form-input>
        </b-form-group>
        <b-form-group
          label-cols="4"
          label-cols-lg="2"
          label-size="sm"
          label="ระยะเวลา"
          label-for="input-sm"
        >
          <b-form-input id="name-input" v-model="item.hour" disabled class="text-right"></b-form-input>
        </b-form-group>
        <b-form-group
          label-cols="4"
          label-cols-lg="2"
          label-size="sm"
          label="ค่าบริการ"
          label-for="input-sm"
        >
          <b-form-input id="name-input" v-model="item.price" disabled class="text-right"></b-form-input>
        </b-form-group>
        <b-form-group
          label-cols="4"
          label-cols-lg="2"
          label-size="sm"
          label="สินค้า 8 บาท"
          label-for="input-sm"
          v-show="item.goods8>0"
        >
          <b-form-input id="name-input" v-model="item.goods8" disabled class="text-right"></b-form-input>
        </b-form-group>
        <b-form-group
          label-cols="4"
          label-cols-lg="2"
          label-size="sm"
          label="สินค้า 13 บาท"
          label-for="input-sm"
          v-show="item.goods13>0"
        >
          <b-form-input id="name-input" v-model="item.goods13" disabled class="text-right"></b-form-input>
        </b-form-group>
        <b-form-group
          label-cols="4"
          label-cols-lg="2"
          label-size="sm"
          label="สินค้า 15 บาท"
          label-for="input-sm"
          v-show="item.goods15>0"
        >
          <b-form-input id="name-input" v-model="item.goods15" disabled class="text-right"></b-form-input>
        </b-form-group>
        <b-form-group
          label-cols="4"
          label-cols-lg="2"
          label-size="sm"
          label="สินค้าอื่นๆ (บาท)"
          label-for="input-sm"
          v-show="item.goodsother!=0"
        >
          <b-form-input id="name-input" v-model="item.goodsother" disabled class="text-right"></b-form-input>
        </b-form-group>
        <b-form-group
          label-cols="4"
          label-cols-lg="2"
          label-size="sm"
          label="ลด 50%"
          label-for="input-sm"
        >
          <b-form-input id="name-input" v-model="item.discount" class="text-right"></b-form-input>
        </b-form-group>
        <b-form-group
          label-cols="4"
          label-cols-lg="2"
          label-size="sm"
          label="รวมเป็นเงิน"
          label-for="input-sm"
        >
          <b-form-input id="name-input" v-model="total" disabled class="text-right"></b-form-input>
        </b-form-group>
        <b-form-group
          label-cols="4"
          label-cols-lg="2"
          label-size="sm"
          label="รับเงิน"
          label-for="input-sm"
        >
          <b-form-input id="name-input" v-model="receive" ref="receive" class="text-right"></b-form-input>
        </b-form-group>
        <b-form-group
          label-cols="4"
          label-cols-lg="2"
          label-size="sm"
          label="ทอนเงิน"
          label-for="input-sm"
        >
          <b-form-input
            id="name-input"
            v-model="change"
            disabled
            class="text-right"
            style="background-color:white;color:green;font-weight: bold;"
            size="lg"
          ></b-form-input>
        </b-form-group>
      </form>
    </b-modal>
    <qrcode-stream @decode="onDecode" @init="onInit" />
  </div>
</template>

<script>
import { QrcodeStream } from "vue-qrcode-reader";

export default {
  components: { QrcodeStream },

  data() {
    return {
      result: "",
      time3hr: "",
      error: "",
      test: "",
      total: "",
      receive: "",
      change: "",
      status: "Back",
      item: [],
    };
  },
  watch: {
    receive: {
      handler(val) {
        var change = this.receive - this.total;
        if (change > 0) this.change = change;
      },
    },
  },
  methods: {
    timeConvert(n) {
      var num = n;
      var hours = num / 60;
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      return rhours + " ชั่วโมง " + rminutes + " นาที";
    },
    onDecode(result) {
      if (result == "") return;
      this.result = result;
      this.postlogin(result);
    },
    showmodal() {
      this.$refs.receive.$el.focus();
    },
    hiddenmodal() {
      this.$parent.showAlert("finish", "success");
      this.back();
    },
    postlogin2() {
      var str = this.test;
      if (str.search("-") > -1) {
        var res = str.split("-");
        var start = parseInt(res[0]);
        var end = parseInt(res[1]);
        for (let i = start; i <= end; i++) {
          var padd = i.toString().padStart(3, "0")
          // console.log(padd);
          this.postlogin(padd);
        }
      } else {
        this.postlogin(this.test);
      }
    },
    postlogin(qr) {
      if (qr.length == 4) {
        this.posttime(qr);
      } else {
        this.time3hr = "";
      }
      const formData = new FormData();
      formData.append("api", "login");
      formData.append("qr", qr);
      axios
        .post(this.$store.state.api, formData)
        .then((response) => {
          if (response.data.rows.length > 0) {
            this.$refs.modal.show();
            this.total = response.data.rows[0].total;
            this.item = response.data.rows[0];
            // console.log(response.data.rows[0].minute);
            this.item.hour = this.timeConvert(response.data.rows[0].minute);
          } else {
            this.$parent.showAlert(response.data.data, "success");
            this.back();
          }
        })
        .catch((e) => {});
    },
    posttime(qr) {
      const formData = new FormData();
      formData.append("api", "check3hr");
      formData.append("qr", qr);
      axios
        .post(this.$store.state.api, formData)
        .then((response) => {
          // console.log(response.data)
          // this.$parent.showAlert(response.data.data, "success");
          this.time3hr = response.data.data + " ครั้ง";
        })
        .catch((e) => {});
    },
    back() {
      if (this.status == "No back") return;
      this.$router.replace({
        name: "home",
      });
    },
    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === "NotAllowedError") {
          this.error = "ERROR: you need to grant camera access permisson";
        } else if (error.name === "NotFoundError") {
          this.error = "ERROR: no camera on this device";
        } else if (error.name === "NotSupportedError") {
          this.error = "ERROR: secure context required (HTTPS, localhost)";
        } else if (error.name === "NotReadableError") {
          this.error = "ERROR: is the camera already in use?";
        } else if (error.name === "OverconstrainedError") {
          this.error = "ERROR: installed cameras are not suitable";
        } else if (error.name === "StreamApiNotSupportedError") {
          this.error = "ERROR: Stream API is not supported in this browser";
        }
      }
    },
  },
};
</script>

<style scoped>
.error {
  font-weight: bold;
  color: red;
}
</style>